var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightbulbOnFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.672 5.21a.947.947 0 0 1 1.339-1.341l1.317 1.315a.947.947 0 1 1-1.339 1.34L3.672 5.21zM11 3.487a1 1 0 1 0 2 0v-1.49a1 1 0 1 0-2 0v1.49zM.5 11.97c0 .551.447.998.997.998h1.506a.997.997 0 1 0 0-1.995H1.497a.997.997 0 0 0-.997.997zM15 19.447a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-2.351c-1.79-1.037-3-2.962-3-5.177 0-3.301 2.69-5.984 6-5.984s6 2.683 6 5.984c0 2.215-1.21 4.14-3 5.177v2.351zm5-7.478c0 .551.447.998.997.998h1.506a.997.997 0 1 0 0-1.995h-1.506a.997.997 0 0 0-.997.997zM9.5 22.442c0 .551.447.998.997.998h3.006a.997.997 0 0 0 0-1.995h-3.006a.997.997 0 0 0-.997.997zm8.168-15.924a.943.943 0 0 1 0-1.334l1.32-1.323a.947.947 0 1 1 1.338 1.34L19 6.52a.943.943 0 0 1-1.332 0z",
    fill: "#A4B0C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulbOnFilled);
export default __webpack_public_path__ + "static/media/lightbulb-on-filled.1fb11fdf06b21eac2fe41da84fb482b8.svg";
export { ForwardRef as ReactComponent };